<template>
  <div id="new-bank-account">
    <bank-account-form :isDark="true" :inDialog="true" :mode="mode" :record="record" :errors="errors" @createBankAccount="createBankAccount" @cancel="onCancel" />
  </div>
</template>

<script>
import utils from "../../shared/Utils"
import {crypto_currencies, local_currencies}  from "../../shared/Currencies"
import BankAccountsForm from "../../BankAccountsForm"

export default {
  name: 'NewBankAccountView',
  components: {
    'bank-account-form': BankAccountsForm,
  },
  props: {
    subject: {
      type: Object
    },
    operation: {
      type: String
    },
    toCurrency: {
      type: String
    }
  },
  data() {
    return {
      record: {
        bank: { name: '', code: '', ispb: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: '',
        pix_info: {key: '', type: ''}
      },
      mode: 'insert',
      errors: {},
      url: '',
      localCurrencies: local_currencies,
      cryptoCurrencies: crypto_currencies
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    is_blank(field) {
      return String(field).trim() == ''
    },
    createBankAccount() {
      let bank_account = {...this.record}
      if (bank_account.pix_info && bank_account.pix_info.key == "" && bank_account.pix_info.type == "") {
        delete bank_account.pix_info
      }

      if (bank_account.account_type == 'internacional') {
        bank_account.account_type = 'conta-corrente'
      }

      if (this.cryptoCurrencies.includes(bank_account.currency)) {
        delete bank_account.bank.swift

        let bank_code = bank_account.bank && bank_account.bank.code || ''
        let bank_ispb = bank_account.bank && bank_account.bank.ispb || ''
        if (String(bank_code).trim() === '' && String(bank_ispb).trim() === '') {
          delete bank_account.bank
        }
      } else {
        delete bank_account.bank.code
        delete bank_account.bank.ispb
      }

      if (this.localCurrencies.includes(bank_account.currency)) {
        delete bank_account.bank.swift

        let bank_code = bank_account.bank && bank_account.bank.code || ''
        let bank_ispb = bank_account.bank && bank_account.bank.ispb || ''
        if (String(bank_code).trim() === '' && String(bank_ispb).trim() === '') {
          delete bank_account.bank
        }
      } else {
        delete bank_account.bank.code
        delete bank_account.bank.ispb
      }

      const payload = { bank_account }

      let successCallback = (response) => {
        if (response.body.data) {
          this.record = response.body.data
          this.$emit('handle-event', {newBankAccount: this.record})
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        if (response.body.errors) {
          let errors = utils.translateErrors(response.body.errors, this.$root.lang)
          if (errors.bank && errors.bank.code) this.$set(this.errors, 'bank_code', errors.bank.code)
          if (errors.bank && errors.bank.ispb) this.$set(this.errors, 'bank_ispb', errors.bank.ispb)
          if (errors.bank && errors.bank.name) this.$set(this.errors, 'bank_name', errors.bank.name)
        }
      }

      this.errors = {}

      let valid = true
      if (this.record.currency == 'BRL') {
        if (this.is_blank(this.record.bank.name) && this.is_blank(this.record.pix_info.key)) {
          this.$set(this.errors, 'bank_name', this.i18n('Obrigatório'))
          valid = false
        }

        if (
          this.is_blank(this.record.bank.code) &&
          this.is_blank(this.record.bank.ispb) &&
          this.is_blank(this.record.pix_info.key)) {
          this.$set(this.errors, 'bank_code', this.i18n('Obrigatório código ou ISPB do banco'))
          this.$set(this.errors, 'bank_ispb', this.i18n('Obrigatório código ou ISPB do banco'))
          valid = false
        }
        if (this.is_blank(this.record.branch_number) && this.is_blank(this.record.pix_info.key)) {
          this.$set(this.errors, 'branch_number', this.i18n('Obrigatório'))
          valid = false
        }
        if (this.record.pix_info.key && this.is_blank(this.record.pix_info.type)) {
          this.$set(this.errors, 'pix_type', this.i18n('Obrigatório'))
          valid = false
        } else if (this.record.pix_info.type && this.is_blank(this.record.pix_info.key)) {
          this.$set(this.errors, 'pix_key', this.i18n('Obrigatório'))
          valid = false
        }
      } else {
        if (String(this.record.bank.name).trim() == '') {
          this.$set(this.errors, 'bank_name', this.i18n('Obrigatório'))
          valid = false
        }
      }
      if(this.localCurrencies.filter((currency) => currency != "BRL").indexOf(this.record.currency) != -1 && this.is_blank(this.record.bank.code)) {
        this.$set(this.errors, 'bank_code', this.i18n('Obrigatório'))
        valid = false
      }
      if (String(this.record.account_number).trim() == '' && this.is_blank(this.record.pix_info.key)) {
        this.$set(this.errors, 'account_number', this.i18n('Obrigatório'))
        valid = false
      }

      if (valid) {
        const token = this.$cookies.get('api_token')
        this.$http.post(this.url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      }
    },
    onCancel() {
      this.record = {
        bank: { name: '', code: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: '',
      }
      this.errors = {}
      this.$emit('handle-event', {cancel: true})
    }
  },
  mounted() {
    switch(this.operation) {
      case 'receive':
      case 'withdrawal_internal':
        this.url = this.$root.urls.bank_accounts
        break
      default:
        this.url = this.$root.urls.customer__subject__bank_accounts.split('ID').join(this.subject.id)
    }
    this.record.currency = this.toCurrency
  }
}
</script>

<style>
#new-bank-account {
  padding: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTransaction/NewBankAccountView.vue